'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { useEffect } from 'react';
const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
export function Analytics() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  if (!GA_ID) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} strategy="lazyOnload" /><Script id="gtag-init" strategy="lazyOnload">{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}');
          window.gtag = gtag;
        `}</Script></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  if (!GA_ID || typeof window === "undefined") {
    return;
  }
  const sent = new Set();
  const thresholds = [25, 50, 75, 100];
  const onScroll = function onScroll() {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) {
      return;
    }
    const pct = Math.round(scrollTop / docHeight * 100);
    thresholds.forEach(t => {
      if (pct >= t && !sent.has(t)) {
        sent.add(t);
        window.gtag?.("event", "scroll_depth", {
          value: t,
          percent_scrolled: t
        });
      }
    });
  };
  window.addEventListener("scroll", onScroll, {
    passive: true
  });
  return () => window.removeEventListener("scroll", onScroll);
}